import { memo, useState } from 'react';
import cn from 'classnames';
import { Container } from '@/shared/ui/Container';
import { CustomInput } from '@/shared/ui/Fields';
import { Svg } from '@/shared/ui/Svg';
import SearchIcon from '@/shared/assets/icons/search.svg';
import { searchInputClassName } from '@/shared/config/searchInputClassName';
import type { DashboardTab } from '../../config/dashboardTabs';
import { DashboardTabs } from '../components/DashboardTabs';
import { ExportAnalyticsModal } from '../components/ExportAnalyticsModal';
import { GeneralInfoTab } from '../tabs/GeneralInfoTab/GeneralInfoTab';
import { StudentAnalyticsTab } from '../tabs/StudentAnalyticsTab/StudentAnalyticsTab';
import { CourseStatisticsTab } from '../tabs/CourseStatisticsTab/CourseStatisticsTab';
import { AssignmentsTestsTab } from '../tabs/AssignmentsTestsTab/AssignmentsTestsTab';
import { LecturerStatisticsTab } from '../tabs/LecturerStatisticsTab/LecturerStatisticsTab';
import { CertificatesTab } from '../tabs/CertificatesTab/CertificatesTab';
import { ScormTab } from '../tabs/ScormTab';
import styles from './HomeView.module.scss';

interface HomeViewProps {
  className?: string;
}

export const HomeView = memo(({ className }: HomeViewProps) => {
  const [tab, setTab] = useState<DashboardTab>('general');
  const [search, setSearch] = useState('');
  const [exportOpen, setExportOpen] = useState(false);

  const openExport = () => setExportOpen(true);

  return (
    <div className={cn(styles.root, className)}>
      <Container className="flex flex-col gap-6">
        <h1 className="sr-only">Dashboard</h1>

        <CustomInput aria-label="Search"
          className={searchInputClassName}
          startContent={<Svg Icon={SearchIcon} />}
          placeholder="Search"
          value={search}
          onValueChange={setSearch}
        />

        <DashboardTabs value={tab} onChange={setTab} />

        {tab === 'general' && <GeneralInfoTab onExport={openExport} />}
        {tab === 'students' && <StudentAnalyticsTab onExport={openExport} />}
        {tab === 'courses' && <CourseStatisticsTab onExport={openExport} />}
        {tab === 'assignments' && <AssignmentsTestsTab onExport={openExport} />}
        {tab === 'lecturers' && <LecturerStatisticsTab onExport={openExport} />}
        {tab === 'certificates' && <CertificatesTab onExport={openExport} />}
        {tab === 'scorm' && <ScormTab />}
      </Container>

      <ExportAnalyticsModal isOpen={exportOpen} onOpenChange={setExportOpen} />
    </div>
  );
});

HomeView.displayName = 'HomeView';
